import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import toast from "react-hot-toast";

export default function SocialLoginProvidersPage() {
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);

  const navigate = useNavigate();

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/social/settings");
      setSettings(res.data?.data || {});
    } catch (e) {
      toast.error("Failed to load social login settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const providers = [
    {
      key: "facebook",
      title: "Facebook Login",
      desc: "Configure Facebook OAuth credentials",
      enabled: !!settings?.enable_facebook,
    },
    {
      key: "google",
      title: "Google Login",
      desc: "Configure Google OAuth credentials",
      enabled: !!settings?.enable_google,
    },
    {
      key: "apple",
      title: "Apple Login",
      desc: "Configure Apple Sign-In credentials",
      enabled: !!settings?.enable_apple,
    },
  ];

  const appSettingsCards = [
    {
      key: "app-settings",
      title: "Site / APP Settings",
      desc: "Configure site and application-level settings",
      path: "/admin/settings/app-settings",
    },
  ];

  const dynamicLinksCards = [
    {
      key: "dynamic-links",
      title: "APP Dynamic Links Settings",
      desc: "Configure deep link URLs used within the mobile application",
      path: "/admin/settings/dynamic-links",
    },
  ];

  if (loading) return <div className="text-sm">Loading...</div>;

  return (
    <div className="bg-white rounded-2xl p-6">
      <h1 className="text-2xl font-bold">Social Login Settings</h1>
      <p className="text-sm text-gray-500 mt-2">
        Select a provider card to manage credentials.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        {providers.map((p) => (
          <div
            key={p.key}
            onClick={() => navigate(`/admin/settings-management/${p.key}`)}
            className="border rounded-2xl p-6 cursor-pointer hover:shadow-md transition"
          >
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-bold">{p.title}</h2>

              <span
                className={`text-xs px-3 py-1 rounded-full font-semibold ${
                  p.enabled
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {p.enabled ? "Enabled" : "Disabled"}
              </span>
            </div>

            <p className="text-sm text-gray-500 mt-3">{p.desc}</p>

            <button
              type="button"
              className="mt-5 bg-blue-600 text-white px-4 py-2 rounded-xl text-sm font-semibold hover:opacity-90"
            >
              Manage
            </button>
          </div>
        ))}
      </div>

      <h2 className="text-xl font-bold mt-10">Site / APP Settings</h2>
      <p className="text-sm text-gray-500 mt-1">
        Configure application-level settings.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        {appSettingsCards.map((card) => (
          <div
            key={card.key}
            onClick={() => navigate(card.path)}
            className="border rounded-2xl p-6 cursor-pointer hover:shadow-md transition"
          >
            <h2 className="text-lg font-bold">{card.title}</h2>
            <p className="text-sm text-gray-500 mt-3">{card.desc}</p>
            <button
              type="button"
              className="mt-5 bg-blue-600 text-white px-4 py-2 rounded-xl text-sm font-semibold hover:opacity-90"
            >
              Manage
            </button>
          </div>
        ))}
      </div>

      {/* <h2 className="text-xl font-bold mt-10">APP Dynamic Links Settings</h2>
      <p className="text-sm text-gray-500 mt-1">
        Configure deep link URLs used within the mobile application.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        {dynamicLinksCards.map((card) => (
          <div
            key={card.key}
            onClick={() => navigate(card.path)}
            className="border rounded-2xl p-6 cursor-pointer hover:shadow-md transition"
          >
            <h2 className="text-lg font-bold">{card.title}</h2>
            <p className="text-sm text-gray-500 mt-3">{card.desc}</p>
            <button
              type="button"
              className="mt-5 bg-blue-600 text-white px-4 py-2 rounded-xl text-sm font-semibold hover:opacity-90"
            >
              Manage
            </button>
          </div>
        ))}
      </div> */}
    </div>
  );
}
